import { SET_CHILDRENS_COUNT, SET_CHILDREN_INFO } from "./types";

export const updateChildrensCount = ( newCount ) => {
  return {
    type: SET_CHILDRENS_COUNT,
    payload: newCount,
  };
};

export const updateChildrens = ( index=0, key='name', value='') => {
  return {
    type: SET_CHILDREN_INFO,
    payload: {index, key, value},
  };
};
